import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import * as api from '../lib/api';

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // {email, role, name}
  const [loading, setLoading] = useState(true);

  const logout = useCallback(() => {
    localStorage.removeItem('fier_token');
    localStorage.removeItem('fier_user');
    setUser(null);
  }, []);

  useEffect(() => {
    api.setUnauthorizedHandler(() => logout());
    const token = localStorage.getItem('fier_token');
    const cached = localStorage.getItem('fier_user');
    if (token && cached) {
      setUser(JSON.parse(cached));
      api.getMe().then((me) => {
        setUser(me);
        localStorage.setItem('fier_user', JSON.stringify(me));
      }).catch(() => logout()).finally(() => setLoading(false));
    } else {
      setLoading(false);
    }
  }, [logout]);

  const signIn = async (email, password) => {
    const data = await api.login(email, password);
    localStorage.setItem('fier_token', data.access_token);
    const u = { email: data.email, role: data.role, name: data.name };
    localStorage.setItem('fier_user', JSON.stringify(u));
    setUser(u);
    return u;
  };

  const isAdmin = user?.role === 'admin';
  const isControl = user?.role === 'control';

  // Permessi di scrittura:
  // - admin: tutto
  // - control (Controllo di gestione): SOLA LETTURA ovunque, tranne la sezione
  //   "Analisi CG (Avanzata)" dove ha pieno accesso (canWriteCG).
  const canWriteList = () => isAdmin;            // Ricavi/Costi/Mix/Produzione: solo admin
  const canWriteCG = () => isAdmin || isControl; // Sezione Analisi CG: admin + control

  return (
    <AuthContext.Provider value={{ user, loading, signIn, logout, isAdmin, isControl, canWriteList, canWriteCG }}>
      {children}
    </AuthContext.Provider>
  );
}
